import {
  computed,
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, NgControl, Validators } from '@angular/forms';

@Directive({
  selector: '[fcInput]',
  standalone: true,
  host: {
    class: 'fc-input',
  },
  exportAs: 'fcInput',
})
export class InputDirective implements OnInit {
  elRef = inject(ElementRef);
  ngControl = inject(NgControl, { optional: true });
  private readonly destroyRef = inject(DestroyRef);

  formControl: FormControl | null = null;

  private readonly controlStatusVersion = signal(0);

  readonly isRequired = computed(() => {
    this.controlStatusVersion();
    return this.formControl?.hasValidator(Validators.required) ?? false;
  });

  ngOnInit() {
    if (this.ngControl && this.ngControl.control instanceof FormControl) {
      this.formControl = this.ngControl.control;
      this.formControl.events
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() =>
          this.controlStatusVersion.update((version) => version + 1),
        );
      this.controlStatusVersion.update((version) => version + 1);
    }
  }
}
